import CertificationModal from './CertificationModal';

export default CertificationModal;
